export class RouterExceptionLogViewModel {
  ExceptionId: number;
  OrgId?: number;
  OrgName: string;
  OrderId?: number;
  AccessionNo: string;
  InstanceUid: string;
  ExceptionType: string;
  ExceptionTag: string;
  ExceptionLevel?: number;
  ExceptionMessage: string;
  StackTrace: string;
  ExtraData: string;
  RouterVersion: string;
  CreatedBy?: number;
  CreatedOn?: Date;
  LastModifiedBy?: number;
  LastModifiedOn?: Date;
}


export class RouterExceptionLogQueryModel {

  OrgId?: number;
  public StartDate: string;
  public EndDate: string;
}